import type { DayPlan, DayOfWeek } from '../types/exercise';

const PLAN: Record<DayOfWeek, DayPlan> = {
  mon: {
    kind: 'training',
    dayOfWeek: 'mon',
    title: 'Aktivieren — Mobility & Glutes',
    warmup:
      '• Cat-Cow im Vierfuessler 10 Wdh\n• Hueftbeuger-Dehnung im Ausfallschritt 30 sec/Seite\n• Bodyweight-Mini-Squats langsam 10 Wdh',
    entries: [
      { exerciseId: 'custom.glute-bridge', sets: 3, reps: '15' },
      { exerciseId: 'custom.bird-dog', sets: 3, reps: '10/Seite' },
      { exerciseId: '8.54', sets: 2, reps: '12/Seite' },
      { exerciseId: '8.63', sets: 2, reps: '15' },
    ],
  },
  tue: {
    kind: 'training',
    dayOfWeek: 'tue',
    title: 'Push — Brust, Schulter, Trizeps',
    warmup:
      '• Schulterkreisen vor + zurueck 10 pro Richtung\n• Brustoeffner am Tuerrahmen 30 sec/Seite\n• Aussenrotation mit kurzem Band am Tueranker 10/Seite (Rotatorenmanschette)',
    entries: [
      { exerciseId: '8.3', sets: 3, reps: '12' },
      { exerciseId: '8.8', sets: 3, reps: '10' },
      { exerciseId: '8.34', sets: 2, reps: '12/Seite' },
      { exerciseId: '8.1', sets: 3, reps: '12' },
      { exerciseId: 'custom.side-plank', sets: 2, reps: '20 sec/Seite' },
    ],
  },
  wed: {
    kind: 'training',
    dayOfWeek: 'wed',
    title: 'Cardio-Zirkel',
    warmup:
      '• Marschieren auf der Stelle mit Knieanheben 60 sec\n• Schulterkreisen vor + zurueck 10 pro Richtung\n• Bodyweight-Squats langsam 10 Wdh',
    circuitNote:
      'Zirkelformat: alle drei Uebungen hintereinander, 60 sec Pause, drei Runden.',
    entries: [
      { exerciseId: 'custom.mountain-climbers', sets: 3, reps: '30 sec' },
      { exerciseId: '8.54', sets: 3, reps: '20/Seite' },
      { exerciseId: 'custom.dead-bug', sets: 3, reps: '10/Seite' },
    ],
  },
  thu: {
    kind: 'pilates',
    dayOfWeek: 'thu',
    title: 'Pilates-Tag',
    body:
      'Heute Abend hast du deinen Pilates-Kurs. Kein eigenes Band-Training noetig — Erholung ist Teil des Plans.',
  },
  fri: {
    kind: 'training',
    dayOfWeek: 'fri',
    title: 'Beine — Glutes & Stabilitaet',
    warmup:
      '• Sidesteps mit Mini-Band um die Knie 1 × 20/Seite\n• Glute Bridge ohne Band 10 Wdh\n• 90/90 Hip Stretch 30 sec/Seite (Hueftrotation)',
    entries: [
      { exerciseId: 'custom.glute-bridge', sets: 3, reps: '15' },
      { exerciseId: '8.47', sets: 3, reps: '12' },
      { exerciseId: '8.43', sets: 3, reps: '12/Seite' },
      { exerciseId: '8.44', sets: 2, reps: '12/Seite' },
      { exerciseId: '8.64', sets: 2, reps: '12/Seite' },
    ],
  },
  sat: {
    kind: 'training',
    dayOfWeek: 'sat',
    title: 'Pull & Core — Ruecken & Bizeps',
    warmup:
      '• Cat-Cow 10 Wdh (Brustwirbelsaeule, vor Rudern)\n• Schulterkreisen vor + zurueck 10 pro Richtung\n• Aussenrotation mit kurzem Band 10/Seite (Schulter, vor Latzug-Movements)',
    entries: [
      { exerciseId: '8.6', sets: 3, reps: '12' },
      { exerciseId: '8.33', sets: 3, reps: '12' },
      { exerciseId: '8.31', sets: 3, reps: '12' },
      { exerciseId: 'custom.pallof-press', sets: 2, reps: '10/Seite' },
      { exerciseId: 'custom.bird-dog', sets: 2, reps: '10/Seite' },
    ],
  },
  sun: {
    kind: 'recovery',
    dayOfWeek: 'sun',
    title: 'Recovery',
    activities: [
      'Indoor-Stretching: Schultern, Nacken, Hueftbeuger, Waden — je 30 sec/Seite.',
      'Optional: Spaziergang draussen (einziger Outdoor-Tag).',
      '90/90 Hip Stretch als Cooldown — 60 sec/Seite.',
    ],
  },
};

export function getPlanForDay(day: DayOfWeek): DayPlan {
  return PLAN[day];
}
